  /* eslint-disable */
import Swal from 'sweetalert2';
import Svg from "_assets/svg";
import Alert_Success from '_assets/images/hello.png'

// ALERT TYPE
export const AlertType = {
  ERROR : 'error',
  SUCCESS : 'success',
  WARNING : 'warning',
  QUESTION : 'question',
  INFO : 'info'
}

// ALERT TEXT
export const AlertTitle = {
  SUCCESS: 'Success!',
  ERROR: 'Error!',
  WARNING: 'Warning',
  INFO: 'Information',
  QUESTION: 'Question',
};

export const AlertText = {
  SUCCESS: 'Success',
  ERROR: 'Error',
  WARNING: 'Warning',
  SOMETHING: 'Something went wrong!',
  INTERNAL: 'Internal server error!',
  DATA_EMPTY: 'Data Is Not Exist'
};

export const Alert = {

  showStatus: (type, title, text, footer) => {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
      showCloseButton: true,
      footer: footer,
      showConfirmButton: false,
      timerProgressBar: true,
      toast: true,
      position: 'top-end',
      timer: 2500,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });
  },

  showStatusCustom: (type, title, text, footer) => {
    Swal.fire({
      // icon: {Icon},
      iconHtml:  `<img src='alert_success.svg'>`,
      title: title,
      text: text,
      showCloseButton: true,
      footer: footer,
      showConfirmButton: false,
      timerProgressBar: true,
      toast: true,
      position: 'top-end',
      timer: 2500,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });
  }
}